// extracted by mini-css-extract-plugin
export var modal = "_mo-0";